import { createApolloClient } from "../../services/apolloClient";
import { CustomerNotification } from "./types";
import {
  MY_NOTIFICATIONS_QUERY,
  MARK_MY_NOTIFICATIONS_READ_MUTATION,
} from "./queries";

const createClient = () => createApolloClient(true);

export const notificationService = {
  async getMyNotifications(): Promise<CustomerNotification[]> {
    const result = await createClient().query({
      query: MY_NOTIFICATIONS_QUERY,
      fetchPolicy: "network-only",
    });
    return (
      (result.data as { myNotifications?: CustomerNotification[] } | undefined)
        ?.myNotifications ?? []
    );
  },

  async markAllRead(): Promise<void> {
    await createClient().mutate({ mutation: MARK_MY_NOTIFICATIONS_READ_MUTATION });
  },
};
